import client from './client.js';

// ─── Terminales ──────────────────────────────────────────────────────────────

export const getTerminals = () =>
  client.get('/pos/terminals').then((r) => r.data.data);

// ─── Negocio ──────────────────────────────────────────────────────────────────
export const getBusinessInfo = () =>
  client.get('/pos/business-info').then((r) => r.data.data);

// ─── Sesiones ─────────────────────────────────────────────────────────────────

export const getActiveSession = (terminalId) =>
  client.get(`/pos/sessions/active/${terminalId}`).then((r) => r.data.data);

export const getSessions = (params) =>
  client.get('/pos/sessions', { params }).then((r) => r.data.data ?? r.data);

// ─── Movimientos de caja ──────────────────────────────────────────────────────
export const createCashMovement = (sessionId, { type, amount, concept }) =>
  client.post(`/pos/sessions/${sessionId}/movements`, { type, amount, concept }).then((r) => r.data.data);

export const getSessionMovements = (sessionId) =>
  client.get(`/pos/sessions/${sessionId}/movements`).then((r) => r.data.data);

export const openSession = ({ terminal_id, opening_cash, notes }) =>
  client.post('/pos/sessions/open', { terminal_id, opening_cash, notes }).then((r) => r.data.data);

export const closeSession = (sessionId, { closing_cash, notes }) =>
  client.post(`/pos/sessions/${sessionId}/close`, { closing_cash, notes }).then((r) => r.data.data);

// ─── Pagos ────────────────────────────────────────────────────────────────────

export const createPayment = (payload) =>
  client.post('/pos/payments', payload, {
    headers: { 'Idempotency-Key': payload.client_uuid },
  }).then((r) => r.data.data);

export const getPaymentsBySession = (sessionId, params) =>
  client.get(`/pos/sessions/${sessionId}/payments`, { params }).then((r) => r.data);

export const sendReceiptByEmail = (paymentId, { email, items }) =>
  client.post(`/pos/payments/${paymentId}/send-receipt`, { email, items });

export const searchPaymentByFolio = (folio) =>
  client.get('/pos/payments/search', { params: { folio } }).then((r) => r.data.data);

export const refundPayment = (paymentId) =>
  client.post(`/pos/payments/${paymentId}/refund`).then((r) => r.data.data);

export const partialRefundPayment = (paymentId, items, reason) =>
  client.post(`/pos/payments/${paymentId}/partial-refund`, { items, reason }).then((r) => r.data.data);

// ─── Stripe Terminal ──────────────────────────────────────────────────────────

export const getConnectionToken = () =>
  client.post('/pos/terminal/connection-token').then((r) => r.data);

export const createTerminalPaymentIntent = (amount) =>
  client.post('/pos/terminal/payment-intent', { amount }).then((r) => r.data);

// ─── Mercado Pago Point ───────────────────────────────────────────────────────

export const getMpOAuthUrl = () =>
  client.get('/pos/terminal/mp/oauth-url').then((r) => r.data.url);

export const getMpDevices = () =>
  client.get('/pos/terminal/mp/devices').then((r) => r.data.data);

export const createMpPaymentIntent = ({ amount, device_id, external_reference }) =>
  client.post('/pos/terminal/mp/payment-intent', { amount, device_id, external_reference }).then((r) => r.data);

export const getMpPaymentIntentStatus = (intentId) =>
  client.get(`/pos/terminal/mp/payment-intent/${intentId}`).then((r) => r.data);

export const cancelMpPaymentIntent = (intentId, device_id) =>
  client.delete(`/pos/terminal/mp/payment-intent/${intentId}`, { data: { device_id } }).then((r) => r.data);
